import { useEffect, useMemo, useState } from "react";

const ScripsDropDownCellTableData = ({
  setValue,
  scripData,
  dataFetching,
  setSelectedScriptName,
  page,
}) => {
  const [searchText, setSearchText] = useState("");
  const [filteredScrip, setFilterScrip] = useState([]);
  const [isDropDown, setIsDropDown] = useState();

  const sessionFilter = useMemo(() => {
    const raw = sessionStorage.getItem("ca_master_scrip");
    return raw ? JSON.parse(raw) : null;
  }, []);

  useEffect(() => {
    if (searchText?.length > 0) {
      const filter = scripData?.filter((item) =>
        item?.toUpperCase()?.includes(searchText?.toUpperCase()),
      );
      setFilterScrip(filter);
    } else {
      setIsDropDown(false);
      setFilterScrip(scripData);
      setValue((prev) => ({
        ...prev,
        ["scrip_name"]: null,
      }));
      typeof setSelectedScriptName === "function" && setSelectedScriptName();
    }
  }, [scripData, dataFetching, searchText]);

  useEffect(() => {
    if (sessionFilter && page === "CA-MASTER") {
      const { scrip_name } = sessionFilter;
      setSearchText(scrip_name);
      typeof setSelectedScriptName === "function" &&
        setSelectedScriptName(scrip_name);
      setValue((prev) => ({
        ...prev,
        scrip_name: scrip_name,
      }));
      setIsDropDown(false);
    }
  }, [sessionFilter]);

  const handleData = (value) => {
    setIsDropDown(false);
    setSearchText(value);
    setValue((prev) => ({
      ...prev,
      ["scrip_name"]: value,
    }));
    typeof setSelectedScriptName === "function" && setSelectedScriptName(value);
    if (page === "CA-MASTER") {
      sessionStorage.setItem(
        "ca_master_scrip",
        JSON.stringify({ scrip_name: value }),
      );
    }
  };

  return (
    <>
      <div
        className={`flex h-full w-full flex-col rounded-[4px] bg-[#f5f5f5] `}
      >
        <div className="h-full w-full rounded bg-transparent px-2">
          <input
            value={searchText || ""}
            placeholder="Search Scrip"
            className="w-full rounded-[4px] bg-[#f5f5f5] py-[0.5rem] text-[14px] text-[#868686] focus:outline-none"
            onChange={(e) => {
              setSearchText(e.target.value);
              setIsDropDown(true);
              if (e.target.value?.length === 0 && page === "CA-MASTER") {
                sessionStorage.removeItem("ca_master_scrip");
              }
            }}
          />
        </div>
      </div>
      {isDropDown && searchText && searchText?.length > 0 && dataFetching ? (
        dataFetching === "fetched" ? (
          <div className="scrollbar-custom absolute z-[500] mt-[70px] max-h-[300px] w-fit min-w-[220px] cursor-pointer overflow-y-scroll rounded-md border-[1px] border-[#e3e3e3] bg-white p-1 shadow-lg drop-shadow-lg">
            {filteredScrip && filteredScrip?.length > 0 ? (
              filteredScrip?.map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => handleData(item)}
                  className={`text-[#434343] hover:bg-[#99c8ff] ${
                    idx === filteredScrip?.length - 1
                      ? ""
                      : "border-b-[1px] border-[#cfcfcf]"
                  } `}
                >
                  {item}
                </div>
              ))
            ) : (
              <div className=" text-center text-[#434343]">No Data</div>
            )}
          </div>
        ) : dataFetching === "fetching" ? (
          <div className="w-lg absolute z-[500] mt-[70px] max-h-[300px] w-full max-w-[250px] rounded-md bg-white p-1 text-center shadow-lg drop-shadow">
            <div className=" text-[#434343]">Loading Data...</div>
          </div>
        ) : (
          <div className="w-lg absolute z-[500] mt-[70px] max-h-[300px] w-full max-w-[250px] rounded-md bg-white p-1 text-center shadow-lg drop-shadow">
            <div className=" text-[#434343]">No Data</div>
          </div>
        )
      ) : null}
    </>
  );
};

export default ScripsDropDownCellTableData;
